import {
  Box,
  Button,
  Center,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Tr,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { AiOutlineMail, AiOutlinePrinter } from "react-icons/ai";
import { BsBoxArrowInLeft } from "react-icons/bs";
import { GiSmartphone } from "react-icons/gi";
import Printer, { print } from 'react-pdf-print'
import {
  BoxHeader,
  Embalagem,
  FlexHeader,
  RegisterBudgetModalAbaProduto,
  RegisterBudgetModalContentProposta,
  RegisterBudgetModalContentPropostaButtonClose,
  RegisterBudgetModalContentPropostaCard,
  RegisterBudgetModalContentPropostaCardContentImageCard,
  RegisterBudgetModalContentPropostaCardContentImageCardEmbalagem,
  RegisterBudgetModalContentPropostaClass,
  RegisterBudgetModalContentPropostaHeader,
  RegisterBudgetModalContentPropostaHeaderNumeroProp,
  RegisterBudgetModalContentPropostaSubheaderContent,
  TitleTableProduct,
} from "./styles";
import Moment from "moment";
import topo from "../../../images/topo-html-fornecimento.png";

export const ModalVisualizarProposta = (dados) => {
  const embalagem = "1/2";
  const observacao = "2/2";
  var codigo_produto_aux = null;
  const ids = ['1'];
  return (
    <>
      <RegisterBudgetModalAbaProduto>
        <RegisterBudgetModalContentPropostaClass>
          <RegisterBudgetModalContentProposta>
            <RegisterBudgetModalContentPropostaButtonClose
              onClick={() => dados.close()}
            >
              <Button
                leftIcon={<AiOutlinePrinter size="25px" />}
                bgColor="#FF5219"
                boxShadow="none !important"
                _hover={{
                  backgroundColor: "#FF5219",
                  opacity: "0.8",
                }}
                _active={{
                  backgroundColor: "#FF5219",
                  opacity: "1",
                }}
                color="white"
                onClick={() => print(ids)}
              >
                Imprimir
              </Button>
              
              <Button
                ml="0.3rem"
                leftIcon={<BsBoxArrowInLeft size="25px" />}
                bgColor="#FF5219"
                boxShadow="none !important"
                _hover={{
                  backgroundColor: "#FF5219",
                  opacity: "0.8",
                }}
                _active={{
                  backgroundColor: "#FF5219",
                  opacity: "1",
                }}
                color="white"
              >
                Fechar
              </Button>
            </RegisterBudgetModalContentPropostaButtonClose>

            {dados.boxproduto.map((data) => {
              var count = 0;

              dados.items.map((obj) => {
                if (
                  parseInt(obj.codigo_produto.toString().trim()) ==
                  parseInt(data.codigo_produto.toString().trim())
                ) {
                  count++;
                }
              });
              return (
                <div id={ids[0]}>
                  <RegisterBudgetModalContentPropostaHeader>
                    <img alt="layout" src={topo} />
                    <BoxHeader>
                      <RegisterBudgetModalContentPropostaHeaderNumeroProp>
                        {dados.proposal.codigo_proposta}
                      </RegisterBudgetModalContentPropostaHeaderNumeroProp>
                      <Flex align="center" h="2vh" color="white" w="300px">
                        <Text>
                          São Paulo, {Moment(new Date()).format("DD/MM/YYYY")}
                        </Text>
                        <Box
                          borderLeft="1px"
                          mr="0.7rem"
                          ml="0.7rem"
                          borderColor="white"
                          h="120%"
                        ></Box>
                        <Text>{Moment(new Date()).format("H:mm:ss")}</Text>
                      </Flex>
                    </BoxHeader>
                  </RegisterBudgetModalContentPropostaHeader>
                  <Flex h="7vh" align="center" w="100%" bgColor="#EEF3FA">
                    <Text fontSize="lg" ml="1rem" mr="2rem">
                      {dados.proposal.dados.apelido == null ||
                      dados.proposal.dados.apelido == "" ? (
                        <strong>Sem Informação</strong>
                      ) : (
                        <Text>
                          Consultor de venda:{" "}
                          <strong>{dados.proposal.dados.apelido}</strong>
                        </Text>
                      )}
                    </Text>

                    <GiSmartphone color="#FF5219" size="35px" />
                    <Text fontSize="lg" color="black" mr="2rem">
                      {dados.proposal.dados.celular_contato == null ||
                      dados.proposal.dados.celular_contato == "" ? (
                        <strong>Sem Informação</strong>
                      ) : (
                        <strong>{dados.proposal.dados.celular_contato}</strong>
                      )}
                    </Text>
                    <AiOutlineMail color="#FF5219" size="35px" />
                    <Text fontSize="lg" ml="0.5rem">
                      {dados.proposal.dados.email_contato == null ||
                      dados.proposal.dados.email_contato == "" ? (
                        <strong>Sem Informação</strong>
                      ) : (
                        <strong>{dados.proposal.dados.email_contato}</strong>
                      )}
                    </Text>
                  </Flex>
                  <RegisterBudgetModalContentPropostaSubheaderContent bgColor="#FF5219">
                    <Text ml="1rem" mr="1rem">
                      {dados.proposal.dados.nome_parceiro == null ||
                      dados.proposal.dados.nome_parceiro == "" ? (
                        <strong>Sem Informação</strong>
                      ) : (
                        <Text>
                          <strong>Cliente: </strong>{" "}
                          {dados.proposal.dados.nome_parceiro}
                        </Text>
                      )}
                    </Text>
                    <Box
                      borderLeft="1px"
                      mr="1rem"
                      borderColor="white"
                      h="60%"
                    ></Box>
                    <Text mr="1rem">
                      {dados.proposal.dados.nome_contato == null ||
                      dados.proposal.dados.nome_contato == "" ? (
                        <strong>Sem Informação</strong>
                      ) : (
                        <Text>
                          <strong>Contato: </strong>{" "}
                          {dados.proposal.dados.nome_contato}
                        </Text>
                      )}
                    </Text>
                    <Box
                      borderLeft="1px"
                      mr="1rem"
                      borderColor="white"
                      h="60%"
                    ></Box>

                    <Text mr="1rem">
                      {dados.proposal.dados.cpf_cnpj_parceiro == null ||
                      dados.proposal.dados.cpf_cnpj_parceiro == "" ? (
                        <strong>Sem Informação</strong>
                      ) : (
                        <Text>
                          <strong>CNPJ/CPF: </strong>
                          {dados.proposal.dados.cpf_cnpj_parceiro}
                        </Text>
                      )}
                    </Text>
                    <Box
                      borderLeft="1px"
                      mr="0.7rem"
                      borderColor="white"
                      h="60%"
                    ></Box>

                    <GiSmartphone color="white" size="25px" />
                    <Text ml="0.5rem" mr="1rem">
                      {dados.proposal.dados.celular_contato == null ||
                      dados.proposal.dados.celular_contato == "" ? (
                        <strong>Sem Informação</strong>
                      ) : (
                        <Text>{dados.proposal.dados.celular_contato}</Text>
                      )}
                    </Text>
                    <Box
                      borderLeft="1px"
                      mr="1rem"
                      borderColor="white"
                      h="60%"
                    ></Box>

                    <AiOutlineMail color="white" size="25px" />
                    <Text ml="0.5rem" mr="1rem">
                      {dados.proposal.dados.email_contato == null ||
                      dados.proposal.dados.email_contato == "" ? (
                        <strong>Sem Informação</strong>
                      ) : (
                        <Text>{dados.proposal.dados.email_contato}</Text>
                      )}
                    </Text>
                  </RegisterBudgetModalContentPropostaSubheaderContent>
                  <RegisterBudgetModalContentPropostaCard
                    style={{ minHeight: 900 + count * 45 + "px" }}
                  >
                    <Center>
                      <Flex
                        borderTop="4px"
                        borderColor="#FF5219"
                        mt="0.3rem"
                        w="980px"
                        h="40vh"
                      >
                        <Box w="60%">
                          {data.img.indexOf("embalagem") != -1 ? (
                            <RegisterBudgetModalContentPropostaCardContentImageCard
                              style={{
                                height: "auto",
                              }}
                            >
                              <img
                                alt="img"
                                style={{ height: "auto" }}
                                src={data.img}
                              />
                            </RegisterBudgetModalContentPropostaCardContentImageCard>
                          ) : (
                            <RegisterBudgetModalContentPropostaCardContentImageCard>
                              <img alt="img" src={data.img} />
                            </RegisterBudgetModalContentPropostaCardContentImageCard>
                          )}
                        </Box>
                        <Box w="40%">
                          <Text
                            mt="0.5rem"
                            ml="1rem"
                          >
                            <strong>{data.nome_produto}</strong>
                          </Text>
                          <Text mt="-0.3rem" ml="1rem">
                            Cód.: {data.referencia}
                          </Text>
                          <Text ml="1rem" mt="4rem">
                            {data.descricao != undefined ? (
                              data.descricao.length > 210 ? (
                                data.descricao.substring(0, 210) + "..."
                              ) : (
                                data.descricao
                              )
                            ) : (
                              <></>
                            )}
                          </Text>
                          <Flex>
                            <Text
                              fontFamily="gisha ExtraBold"
                              ml="1rem"
                              mt="2rem"
                            >
                              Dimensões:
                            </Text>
                            <Text ml="0.5rem" mt="2rem">
                              {data.dimensoes}
                            </Text>
                          </Flex>
                          {/* {count >= 3 ? <Text>deu certo</Text> : } */}
                          <Text ml="1rem" fontSize="xs">
                            (Esse produto é produzido por diversos fabricantes,
                            portanto as medidas e o peso apresentados podem
                            <br />
                            sofrer pequenas alterações.)
                          </Text>
                        </Box>
                      </Flex>
                    </Center>
                    <Center>
                      <TitleTableProduct>
                        <Text fontSize="12px" ml="1.5rem" mr="3.9rem">
                          QUANTIDADE
                        </Text>

                        <Text fontSize="12px" textAlign="center" mr="3.9rem">
                          GRAVAÇÃO
                        </Text>
                        <Text fontSize="12px" textAlign="center" mr="3.9rem">
                          QUANTIDADE <br /> DE IMPRESSÕES
                        </Text>
                        <Text
                          fontSize="12px"
                          textAlign="center"
                          ml="0.5rem"
                          mr="3.9rem"
                        >
                          COR
                        </Text>
                        <Text
                          fontSize="12px"
                          textAlign="center"
                          ml="0.5rem"
                          mr="3.9rem"
                        >
                          PRAZO DE <br /> PRODUÇÃO
                        </Text>
                        <Text
                          fontSize="12px"
                          textAlign="center"
                          ml="0.5rem"
                          mr="3.9rem"
                        >
                          VALOR <br /> UNITÁRIO
                        </Text>
                        <Text
                          fontSize="12px"
                          textAlign="center"
                          ml="0.5rem"
                          mr="3.9rem"
                        >
                          SUB <br /> TOTAL
                        </Text>
                        <Text fontSize="12px" textAlign="center" ml="0.5rem">
                          VALOR <br />
                          DO FRETE
                        </Text>
                      </TitleTableProduct>
                    </Center>
                    <Center>
                      <Table
                        w="980px"
                        size="sm"
                        variant="striped"
                        colorScheme="blackAlpha"
                      >
                        <Tbody>
                          {dados.items.map((obj) => {
                            if (
                              parseInt(obj.codigo_produto.toString().trim()) ==
                              parseInt(data.codigo_produto.toString().trim())
                            ) {
                              return (
                                <Tr>
                                  <Td w="110px" textAlign="center">
                                    {parseInt(obj.qtd_negociada)}
                                  </Td>
                                  <Td w="110px" textAlign="center">
                                    {obj.descricao_impressao}
                                  </Td>
                                  <Td w="110px" textAlign="center">
                                    {obj.qtd_batida}
                                  </Td>
                                  <Td w="95px" textAlign="center">
                                    {obj.descricao_cor}
                                  </Td>
                                  <Td w="110px" textAlign="center">
                                    {obj.id_prazo_entrega} dias <br /> úteis
                                  </Td>
                                  <Td w="95px" textAlign="center">
                                    {(
                                      Math.round(
                                        parseFloat(obj.valor_unitario) * 100
                                      ) / 100
                                    ).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                  </Td>
                                  <Td w="80px" textAlign="center">
                                    {(
                                      Math.round(
                                        (parseFloat(obj.valor_total) +
                                          parseFloat(obj.valor_frete)) *
                                          100
                                      ) / 100
                                    ).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                  </Td>
                                  <Td w="95px" textAlign="center">
                                    {parseFloat(obj.valor_frete) == "0.00"
                                      ? `Frete Grátis`
                                      : (
                                          Math.round(
                                            parseFloat(obj.valor_frete) * 100
                                          ) / 100
                                        ).toLocaleString("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        })}
                                  </Td>
                                </Tr>
                              );
                            }
                          })}
                        </Tbody>
                      </Table>
                    </Center>

                    {dados.items.map((obj) => {
                      if (
                        parseInt(obj.codigo_produto.toString().trim()) ==
                          parseInt(data.codigo_produto.toString().trim()) &&
                        obj.dados_embalagem != undefined &&
                        obj.token_embalagem != undefined
                      ) {
                        return (
                          <>
                            <Embalagem>
                              <Flex
                                bgColor="#EEF3FA"
                                w="980px"
                                h="43vh"
                                mt="3rem"
                              >
                                <Box w="50%">
                                  <Center>
                                    <VStack mt="1rem" spacing={0}>
                                      <Text>
                                        {obj.dados_embalagem.nome}
                                      </Text>
                                      <Text>cód. {obj.codigo_produto}</Text>
                                    </VStack>
                                  </Center>
                                  <Text ml="1rem" mt="5rem">
                                    {obj.codigo_impressao_embalagem_selecionada
                                      .descricao_impressao ==
                                    "BOX SEM IMPRESSÃO"
                                      ? "Caixa colorida."
                                      : obj
                                          .codigo_impressao_embalagem_selecionada
                                          .descricao_impressao == "LOCALIZADA"
                                      ? "Caixa colorida com sua marca."
                                      : "Caixa total print."}
                                  </Text>
                                  <Flex>
                                    <Text
                                      ml="1rem"
                                      mt="2rem"
                                    >
                                      Dimensões:
                                    </Text>
                                    <Text ml="0.5rem" mt="2rem">
                                      {obj.dados_embalagem.dimensoes}
                                    </Text>
                                  </Flex>
                                  <Text ml="1rem" fontSize="xs">
                                    (Esse produto é produzido por diversos
                                    fabricantes, portanto as medidas e o peso
                                    apresentados podem
                                    <br />
                                    sofrer pequenas alterações.)
                                  </Text>
                                </Box>
                                <Box w="50%">
                                  <RegisterBudgetModalContentPropostaCardContentImageCardEmbalagem
                                    style={{
                                      top: "0px",
                                    }}
                                  >
                                    {obj.codigo_impressao_embalagem_selecionada
                                      .descricao_impressao ==
                                    "BOX SEM IMPRESSÃO" ? (
                                      <img
                                        alt="embalagem"
                                        style={{}}
                                        src={
                                          "https://innovationbrindes.com.br/images/embalagem" +
                                          obj.codigo_cor_embalagem_selecionada
                                            .imagem_box
                                        }
                                      />
                                    ) : obj
                                        .codigo_impressao_embalagem_selecionada
                                        .descricao_impressao == "LOCALIZADA" ? (
                                      <img
                                        alt="embalagem"
                                        style={{}}
                                        src={
                                          "https://innovationbrindes.com.br/images/embalagem" +
                                          obj.codigo_cor_embalagem_selecionada
                                            .imagem_print
                                        }
                                      />
                                    ) : (
                                      <img
                                        alt="embalagem"
                                        style={{}}
                                        src={
                                          "https://innovationbrindes.com.br/images/embalagem" +
                                          obj.codigo_cor_embalagem_selecionada
                                            .imagem_plus +
                                          "/plus/plus1.jpg"
                                        }
                                      />
                                    )}
                                  </RegisterBudgetModalContentPropostaCardContentImageCardEmbalagem>
                                </Box>
                              </Flex>
                            </Embalagem>
                            <Center mt="0.4rem">
                              <TitleTableProduct>
                                <Text fontSize="12px" ml="1.5rem" mr="6.8rem">
                                  QUANTIDADE
                                </Text>

                                <Text
                                  fontSize="12px"
                                  textAlign="center"
                                  mr="6.8rem"
                                >
                                  OPÇÃO DE <br />
                                  IMPRESSÃO
                                </Text>
                                <Text
                                  fontSize="12px"
                                  textAlign="center"
                                  mr="6.8rem"
                                >
                                  COR DA <br />
                                  CAIXA
                                </Text>
                                <Text
                                  fontSize="12px"
                                  textAlign="center"
                                  ml="0.5rem"
                                  mr="6.8rem"
                                >
                                  PRAZO DE <br />
                                  PRODUÇÃO
                                </Text>
                                <Text
                                  fontSize="12px"
                                  textAlign="center"
                                  ml="0.5rem"
                                  mr="6.8rem"
                                >
                                  VALOR <br />
                                  UNITÁRIO
                                </Text>
                                <Text
                                  fontSize="12px"
                                  textAlign="center"
                                  ml="0.5rem"
                                >
                                  VALOR <br />
                                  TOTAL
                                </Text>
                              </TitleTableProduct>
                            </Center>
                            <Center>
                              <Table
                                w="980px"
                                size="sm"
                                variant="striped"
                                colorScheme="blackAlpha"
                              >
                                <Tbody>
                                  <Tr>
                                    <Td w="130px" textAlign="center">
                                      {parseInt(obj.qtd_negociada)}
                                    </Td>
                                    <Td w="210px" textAlign="center">
                                      {obj
                                        .codigo_impressao_embalagem_selecionada
                                        .descricao_impressao ==
                                      "BOX SEM IMPRESSÃO"
                                        ? "Caixa colorida"
                                        : obj
                                            .codigo_impressao_embalagem_selecionada
                                            .descricao_impressao == "LOCALIZADA"
                                        ? "Caixa colorida com sua marca"
                                        : "Caixa total print"}
                                    </Td>
                                    <Td w="120px" textAlign="center">
                                      {
                                        obj.codigo_cor_embalagem_selecionada
                                          .descricao_cor
                                      }
                                    </Td>
                                    <Td w="200px" textAlign="center">
                                      {obj.id_prazo_entrega}
                                    </Td>
                                    <Td w="160px" textAlign="center">
                                      {(
                                        Math.round(
                                          parseFloat(
                                            obj.dados_embalagem.valor_unitario
                                          ) * 100
                                        ) / 100
                                      ).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                      })}
                                    </Td>

                                    <Td textAlign="center">
                                      {(
                                        Math.round(
                                          parseFloat(
                                            obj.cubagem_embalagem
                                              .CubagemUnitaria
                                          ) *
                                            parseFloat(obj.qtd_negociada) *
                                            100
                                        ) / 100
                                      ).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                      })}
                                    </Td>
                                  </Tr>
                                </Tbody>
                              </Table>
                            </Center>
                          </>
                        );
                      }
                    })}

                    <Center mt="0.5rem">
                      <Flex justify="end" h={["4.5vh", "7vh"]} w="980px">
                        <Box p={2} color="white" w="15%" h="50px" bgColor="#FF5219">
                          <Text textAlign="center">VALOR TOTAL</Text>
                          <Text fontSize="12px" mt="-0.5rem" textAlign="center">
                            (item + frete)
                          </Text>
                        </Box>
                        <Box p={2} w="15%" h="50px" bgColor="#EEF3FA">
                          <Text color="#FF5219" textAlign="center">
                            <strong>
                              {[0].map((aux) => {
                                let valor_total = 0;

                                dados.items.map((obj) => {
                                  if (
                                    parseInt(
                                      obj.codigo_produto.toString().trim()
                                    ) ==
                                    parseInt(
                                      data.codigo_produto.toString().trim()
                                    )
                                  ) {
                                    valor_total =
                                      valor_total + parseFloat(obj.valor_total);
                                  }

                                  if (
                                    parseInt(
                                      obj.codigo_produto.toString().trim()
                                    ) ==
                                      parseInt(
                                        data.codigo_produto.toString().trim()
                                      ) &&
                                    obj.dados_embalagem != undefined &&
                                    obj.token_embalagem != undefined
                                  ) {
                                    valor_total =
                                      valor_total +
                                      (parseFloat(
                                        obj.cubagem_embalagem.CubagemUnitaria
                                      ) *
                                        parseFloat(obj.qtd_negociada) *
                                        100) /
                                        100;
                                  }
                                });
                                return (
                                  (parseFloat(valor_total) * 100) /
                                  100
                                ).toLocaleString("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                });
                              })}
                            </strong>
                          </Text>
                        </Box>
                      </Flex>
                    </Center>
                    {dados.items.map((obj) => {
                      if (
                        obj.dados_embalagem == undefined &&
                        obj.token_embalagem == undefined &&
                        parseInt(obj.codigo_produto.toString().trim()) ==
                          parseInt(data.codigo_produto.toString().trim())
                      ) {
                        return (
                          <>
                            <RegisterBudgetModalContentPropostaHeader>
                              <img alt="layout" src={topo} />
                              <BoxHeader>
                                <RegisterBudgetModalContentPropostaHeaderNumeroProp>
                                  {dados.proposal.codigo_proposta}
                                </RegisterBudgetModalContentPropostaHeaderNumeroProp>
                                <Flex
                                  align="center"
                                  h="2vh"
                                  color="white"
                                  w="300px"
                                >
                                  <Text>
                                    São Paulo,{" "}
                                    {Moment(new Date()).format("DD/MM/YYYY")}
                                  </Text>
                                  <Box
                                    borderLeft="1px"
                                    mr="0.7rem"
                                    ml="0.7rem"
                                    borderColor="white"
                                    h="120%"
                                  ></Box>
                                  <Text>
                                    {Moment(new Date()).format("H:mm:ss")}
                                  </Text>
                                </Flex>
                              </BoxHeader>
                            </RegisterBudgetModalContentPropostaHeader>
                          </>
                        );
                      }
                    })}

                    <Flex mt="1.5rem" w="100%">
                      <FlexHeader w="97%"></FlexHeader>
                      <Text justify="end" color="#FF5219">
                        <strong>{embalagem}</strong>
                      </Text>
                    </Flex>
                  </RegisterBudgetModalContentPropostaCard>
                  {dados.items.map((obj) => {
                    if (
                      obj.dados_embalagem != undefined &&
                      obj.token_embalagem != undefined &&
                      parseInt(obj.codigo_produto.toString().trim()) ==
                        parseInt(data.codigo_produto.toString().trim())
                    ) {
                      return (
                        <>
                          <RegisterBudgetModalContentPropostaHeader>
                            <img alt="layout" src={topo} />
                            <BoxHeader>
                              <RegisterBudgetModalContentPropostaHeaderNumeroProp>
                                {dados.proposal.codigo_proposta}
                              </RegisterBudgetModalContentPropostaHeaderNumeroProp>
                              <Flex
                                align="center"
                                h="2vh"
                                color="white"
                                w="300px"
                              >
                                <Text>
                                  São Paulo,{" "}
                                  {Moment(new Date()).format("DD/MM/YYYY")}
                                </Text>
                                <Box
                                  borderLeft="1px"
                                  mr="0.7rem"
                                  ml="0.7rem"
                                  borderColor="white"
                                  h="120%"
                                ></Box>
                                <Text>
                                  {Moment(new Date()).format("H:mm:ss")}
                                </Text>
                              </Flex>
                            </BoxHeader>
                          </RegisterBudgetModalContentPropostaHeader>
                          <Flex
                            h="7vh"
                            align="center"
                            w="100%"
                            bgColor="#EEF3FA"
                          >
                            <Text fontSize="lg" ml="1rem" mr="2rem">
                              {dados.proposal.dados.apelido == null ||
                              dados.proposal.dados.apelido == "" ? (
                                <strong>Sem Informação</strong>
                              ) : (
                                <Text>
                                  Consultor de venda:{" "}
                                  <strong>
                                    {dados.proposal.dados.apelido}
                                  </strong>
                                </Text>
                              )}
                            </Text>

                            <GiSmartphone color="#FF5219" size="35px" />
                            <Text fontSize="lg" color="black" mr="2rem">
                              {dados.proposal.dados.celular_contato == null ||
                              dados.proposal.dados.celular_contato == "" ? (
                                <strong>Sem Informação</strong>
                              ) : (
                                <strong>
                                  {dados.proposal.dados.celular_contato}
                                </strong>
                              )}
                            </Text>
                            <AiOutlineMail color="#FF5219" size="35px" />
                            <Text fontSize="lg" ml="0.5rem">
                              {dados.proposal.dados.email_contato == null ||
                              dados.proposal.dados.email_contato == "" ? (
                                <strong>Sem Informação</strong>
                              ) : (
                                <strong>
                                  {dados.proposal.dados.email_contato}
                                </strong>
                              )}
                            </Text>
                          </Flex>
                          <RegisterBudgetModalContentPropostaSubheaderContent bgColor="#FF5219">
                            <Text ml="1rem" mr="1rem">
                              {dados.proposal.dados.nome_parceiro == null ||
                              dados.proposal.dados.nome_parceiro == "" ? (
                                <strong>Sem Informação</strong>
                              ) : (
                                <Text>
                                  <strong>Cliente: </strong>{" "}
                                  {dados.proposal.dados.nome_parceiro}
                                </Text>
                              )}
                            </Text>
                            <Box
                              borderLeft="1px"
                              mr="1rem"
                              borderColor="white"
                              h="60%"
                            ></Box>
                            <Text mr="1rem">
                              {dados.proposal.dados.nome_contato == null ||
                              dados.proposal.dados.nome_contato == "" ? (
                                <strong>Sem Informação</strong>
                              ) : (
                                <Text>
                                  <strong>Contato: </strong>{" "}
                                  {dados.proposal.dados.nome_contato}
                                </Text>
                              )}
                            </Text>
                            <Box
                              borderLeft="1px"
                              mr="1rem"
                              borderColor="white"
                              h="60%"
                            ></Box>

                            <Text mr="1rem">
                              {dados.proposal.dados.cpf_cnpj_parceiro == null ||
                              dados.proposal.dados.cpf_cnpj_parceiro == "" ? (
                                <strong>Sem Informação</strong>
                              ) : (
                                <Text>
                                  <strong>CNPJ/CPF: </strong>
                                  {dados.proposal.dados.cpf_cnpj_parceiro}
                                </Text>
                              )}
                            </Text>
                            <Box
                              borderLeft="1px"
                              mr="0.7rem"
                              borderColor="white"
                              h="60%"
                            ></Box>

                            <GiSmartphone color="white" size="25px" />
                            <Text ml="0.5rem" mr="1rem">
                              {dados.proposal.dados.celular_contato == null ||
                              dados.proposal.dados.celular_contato == "" ? (
                                <strong>Sem Informação</strong>
                              ) : (
                                <Text>
                                  {dados.proposal.dados.celular_contato}
                                </Text>
                              )}
                            </Text>
                            <Box
                              borderLeft="1px"
                              mr="1rem"
                              borderColor="white"
                              h="60%"
                            ></Box>

                            <AiOutlineMail color="white" size="25px" />
                            <Text ml="0.5rem" mr="1rem">
                              {dados.proposal.dados.email_contato == null ||
                              dados.proposal.dados.email_contato == "" ? (
                                <strong>Sem Informação</strong>
                              ) : (
                                <Text>
                                  {dados.proposal.dados.email_contato}
                                </Text>
                              )}
                            </Text>
                          </RegisterBudgetModalContentPropostaSubheaderContent>
                          <Center>
                            <Flex
                              w="980px"
                              fontSize="18px"
                              mt="4rem"
                              bgColor="gray.700"
                              color="white"
                              h="7vh"
                              align="center"
                              justify="center"
                            >
                              <strong>OBSERVAÇÕES GERAIS</strong>
                            </Flex>
                          </Center>
                          <Center>
                            <Flex
                              w="980px"
                              mt="5rem"
                              h="8vh"
                              align="center"
                              bgColor="#EEF3FA"
                              W="100%"
                            >
                              <Box>
                                <Text w="130px" fontSize="14px">
                                  <strong>
                                    CONDIÇÕES <br /> DE PAGAMENTO:
                                  </strong>
                                </Text>
                              </Box>
                              <Box>
                                <Text fontSize="14px" ml="1rem">
                                  Fatura: 14 DIAS ou a combina (mediente
                                  aprovação de análise de crédito); Cartão de
                                  Crédito com acrescimo de 4% (quatro porcento).
                                  Importante: O prazo de produção somente
                                  iniciará após a aprovação da análise de
                                  crédito ou a confirmação do pagamento.
                                </Text>
                              </Box>
                            </Flex>
                          </Center>
                          <Center>
                            <Flex
                              w="980px"
                              h="8vh"
                              align="center"
                              bgColor="white"
                              W="100%"
                            >
                              <Box>
                                <Text w="130px" fontSize="14px">
                                  <strong>
                                    PRAZO DA <br />
                                    PROPOSTA:
                                  </strong>
                                </Text>
                              </Box>
                              <Box>
                                <Text fontSize="14px" ml="1rem">
                                  2 dias ou por enquanto durarem nossos
                                  estoques. Caso o produto/cor escolhido esteja
                                  em falta ou tenha sofrido alteração de
                                  valores, daremos uma opção de produto similar.
                                </Text>
                              </Box>
                            </Flex>
                          </Center>
                          <Center>
                            <Flex
                              w="980px"
                              h="11vh"
                              align="center"
                              bgColor="#EEF3FA"
                              W="100%"
                            >
                              <Box>
                                <Text w="130px" fontSize="14px">
                                  <strong>FRETE:</strong>
                                </Text>
                              </Box>
                              <Box>
                                <Text fontSize="14px" ml="1rem">
                                  FOB - por conta do cliente. Para pedidos
                                  inferiores ao valor de R$ 2.000,00 será
                                  cobrado uma taxa de R$ 80,00 para São Paulo -
                                  Capital. Caso não concorde com a taxa de
                                  entrega o material setá disponibilizado para
                                  retirada. *Nós comprometemos a produzir seus
                                  produtos no prazo solicitado em seu orçamento.
                                  Não nos responsabilizamos por eventuais
                                  atrasos na entrega de seus produtos, quando
                                  realizadas por meio de transportadoras ou
                                  correios.
                                </Text>
                              </Box>
                            </Flex>
                          </Center>
                          <Center>
                            <Flex
                              w="980px"
                              h="20vh"
                              align="center"
                              bgColor="white"
                              W="100%"
                            >
                              <Box>
                                <Text w="130px" fontSize="14px">
                                  <strong>SOBRE ICMS ST:</strong>
                                </Text>
                              </Box>
                              <Box>
                                <Text fontSize="14px" ml="1rem">
                                  Empresa optante pelo Simples não da direito ao
                                  Crédito de ICMS. 1º. Nas operações
                                  interestaduais realizadas com contribuintes,
                                  cujo Estado ﬁrmou Protocolos ou Convênios com
                                  o Estado de São Paulo, que estabelece o regime
                                  de substituição tributaria , a ELE ﬁca
                                  atribuída a responsabilidade pela retençãoe
                                  recolhimento do imposto em favor do Estado
                                  destinatário .O orçamento acima , sofrerá
                                  alteração quanto ao ICMS-ST , pois cada Estado
                                  tem uma singularidade e alíquota diferenciada,
                                  cujo imposto será retido, recolhido, lançado
                                  na NF-E e no respectivo boleto. 2º. Os Estados
                                  que forem signatários do Protocolo ICMS
                                  no.21/2011 cujo teor, estabelece a favor da
                                  unidade federada do destino da mercadoria, o
                                  ICMS devido na operação interestadual em que o
                                  consumidor ﬁnal adquire mercadoria sob
                                  encomenda de forma não presencial. Caso o
                                  cliente se encaixe nessa situação o imposto
                                  será, retido,recolhido, lançado na NF-E e no
                                  respectivo boleto.
                                </Text>
                              </Box>
                            </Flex>
                          </Center>
                          <Center>
                            <Flex
                              w="980px"
                              h="8vh"
                              align="center"
                              bgColor="#EEF3FA"
                              W="100%"
                            >
                              <Box>
                                <Text w="130px" fontSize="14px">
                                  <strong>TROCA:</strong>
                                </Text>
                              </Box>
                              <Box>
                                <Text fontSize="14px" ml="1rem">
                                  Nos termos do art. 24 da Lei 8078/90, os
                                  produtos terão garantia pelo prazo de 30
                                  (trinta) dias quando não duráveis e 90
                                  (noventa) dias quando duráveis, ambos contados
                                  da data de sua entrega.
                                </Text>
                              </Box>
                            </Flex>
                          </Center>
                          <Center>
                            <Flex
                              w="980px"
                              h="8vh"
                              align="center"
                              bgColor="white"
                              W="100%"
                            >
                              <Box>
                                <Text w="130px" fontSize="14px">
                                  <strong>
                                    DETALHES DA <br />
                                    PROPOSTA:
                                  </strong>
                                </Text>
                              </Box>
                              <Box>
                                <Text fontSize="14px" ml="1rem">
                                  Considerando fechamento do pedido até o dia
                                  13/04 ás 12:00 Primeiro lote dia: 30/04 de 25
                                  mil unidades (podendo ser antecipado); Segundo
                                  lote dia: 10/05 de 25 mil unidades (podendo
                                  ser antecipado).
                                </Text>
                              </Box>
                            </Flex>
                          </Center>
                          <Flex mt="4rem" w="100%">
                            <FlexHeader w="97%"></FlexHeader>
                            <Text justify="end" color="#FF5219">
                              <strong>{observacao}</strong>
                            </Text>
                          </Flex>
                        </>
                      );
                    }
                  })}
                </div>
              );
            })}

            {/* {dados.boxproduto.map((data) => {
                        var count = 0;
                        dados.items.map((obj) => {
                          if (
                            parseInt(obj.codigo_produto.toString().trim()) ==
                              parseInt(data.codigo_produto.toString().trim()) &&
                            obj.token_embalagem != null
                          ) {
                            count++;
                          }
                        }); */}

            {/* return items.map((obj) => {
                          if (
                            obj.codigo_produto == data.codigo_produto &&
                            obj.dados_embalagem != undefined &&
                            obj.token_embalagem != undefined
                          ) {
                            return ( */}
          </RegisterBudgetModalContentProposta>
        </RegisterBudgetModalContentPropostaClass>
      </RegisterBudgetModalAbaProduto>
    </>
    // );
  );
};
